<template>
    <div v-if="isWechat" class="wx-open-app-btn">
        <wx-open-launch-app
        id="launch-btn"
        class="wx-open-app-btn"
        appid="wxc1265f98df56cd07"
        :extinfo="wxExtinfo(postid)"
        >
            <script type="text/wxtag-template">
                <style>
                    .launch-btn{
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }
                </style>
                <div class="launch-btn"></div>
            </script>
        </wx-open-launch-app>
    </div>
    <div v-else class="wx-open-app-btn" @click="openXBApp"></div>
</template>

<script>
const u = navigator.userAgent;
export default {
    props: {
        postid: String,
        type: String
    },
    data() {
        return {
            isWechat: false,
            isIOS: false,
            isQQ: false,
        }
    },
    methods: {
        openXBApp(){
            // if (this.isQQ && this.isIOS) {
                
            // } else {
            console.log("post_id",this.postid, this.type);
            this.openApp("", "", `life_circle/${this.type}?post_id=${this.postid}`);
            // }
        },
        wxExtinfo(post_id){
            console.log({ business: "life_circle", page: this.type, post_id });
            return encodeURIComponent(JSON.stringify({ business: "life_circle", page: this.type, post_id }))
        }
    },
    created() {
        this.isWechat = u.toLowerCase().indexOf("micromessenger") !== -1; // vx内
        this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // iOS终端
        this.isQQ =
        u.toLowerCase().indexOf(" qq") > -1 ||
        u.toLowerCase().indexOf("mqqbrowser") > -1; //qq
    },
}
</script>

<style lang="less" scoped>
.wx-open-app-btn{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>